import React, { useContext } from 'react'
import { injectIntl, InjectedIntlProps } from 'react-intl'
import { Link } from 'react-router-dom'
import { AppContext, AppContextProps } from 'src/AppContext'
import { LOCALES } from 'src/lib/locale'

import Logo from '@uniiverse/library/assets/cobrand-default.svg'
import TwitterIcon from '@uniiverse/library/assets/icons/twitter.svg'
import InstagramIcon from '@uniiverse/library/assets/icons/instagram.svg'
import FacebookIcon from '@uniiverse/library/assets/icons/facebook.svg'

import { Select } from 'src/elements/Select'
import { locale } from './locale'

const style = require('./Footer.css')


const FooterComponent: React.FunctionComponent<InjectedIntlProps> = ({ intl }) => {
  const { switchLocale }: AppContextProps = useContext(AppContext)

  return (
    <footer className={style.container}>
      <div className={style.content}>
        <div className={style.links}>
          <section>
            <header><span>{intl.formatMessage(locale.getToKnowUs)}</span></header>
            <a href="/about" aria-label={intl.formatMessage(locale.linkToAbout)}><span>{intl.formatMessage(locale.about)}</span></a>
            <a href="https://careers.universe.com" aria-label={intl.formatMessage(locale.linkToJobs)}><span>{intl.formatMessage(locale.jobs)}</span></a>
            <a href="https://blog.universe.com" aria-label={intl.formatMessage(locale.linkToBlog)}><span>{intl.formatMessage(locale.blog)}</span></a>
            <a href="/help" aria-label={intl.formatMessage(locale.linkToGetHelp)}><span>{intl.formatMessage(locale.getHelp)}</span></a>
            <a href="/contact-us" aria-label={intl.formatMessage(locale.linkToContactUs)}><span>{intl.formatMessage(locale.contactUs)}</span></a>
          </section>
          <section>
            <header><span>{intl.formatMessage(locale.findEvents)}</span></header>
            <Link to="/explore" href="/explore" aria-label={intl.formatMessage(locale.linkToTopEvents)}><span>{intl.formatMessage(locale.topEvents)}</span></Link>
          </section>
          <section>
            <header><span>{intl.formatMessage(locale.hostEvents)}</span></header>
            <a href="/overview" aria-label={intl.formatMessage(locale.linkToBecomeHost)}><span>{intl.formatMessage(locale.becomeHost)}</span></a>
            <a href="/features" aria-label={intl.formatMessage(locale.linkToTour)}><span>{intl.formatMessage(locale.tour)}</span></a>
            <a href="/sell-tickets-on-your-website-with-universe-widgets" aria-label={intl.formatMessage(locale.linkToEmbeddableWidgets)}>
              <span>{intl.formatMessage(locale.embeddableWidgets)}</span>
            </a>
            <a href="/customers" aria-label={intl.formatMessage(locale.linkToCustomers)}><span>{intl.formatMessage(locale.customers)}</span></a>
            <a href="/pricing" aria-label={intl.formatMessage(locale.linkToPricing)}><span>{intl.formatMessage(locale.pricing)}</span></a>
            <a href="/ticketmanager" aria-label={intl.formatMessage(locale.linkToGetOnsiteApp)}><span>{intl.formatMessage(locale.getOnsiteApp)}</span></a>
            <a href="https://developers.universe.com" aria-label={intl.formatMessage(locale.linkToDevelopers)}><span>{intl.formatMessage(locale.developers)}</span></a>
          </section>
          <section className={style.locale}>
            <Select
              className={style.localeSelector}
              options={Object.keys(LOCALES).map(l => ({ value: l, text: LOCALES[l] }))}
              onChange={(event) => { switchLocale(event.target.value) }}
              value={intl.locale}
            />
          </section>
        </div>
        <div className={style.bottom}>
          <Link to="/" href="/" aria-label={intl.formatMessage(locale.linkToHomePage)}><Logo /></Link>
          <div className={style.copyright}>
            <a href="/terms" aria-label={intl.formatMessage(locale.linkToTermsAndConditions)}><span>{intl.formatMessage(locale.termsAndConditions)}</span></a>
            <span className={style.pipe}>|</span>
            <a href="/terms-of-use" aria-label={intl.formatMessage(locale.linkToTermsOfUse)}><span>{intl.formatMessage(locale.termsOfUse)}</span></a>
            <span className={style.pipe}>|</span>
            <a href="/privacy" aria-label={intl.formatMessage(locale.linkToPrivacyPolicy)}><span>{intl.formatMessage(locale.privacyPolicy)}</span></a>
            <span className={style.pipe}>|</span>
            <a href="https://www.universe.com/privacy#your-choice-and-rights" aria-label={intl.formatMessage(locale.linkToDoNotSellMyInformation)}>
              <span>{intl.formatMessage(locale.doNotSellMyInformation)}</span>
            </a>
            <span className={style.pipe}>|</span>
            <a href="/cookies" aria-label={intl.formatMessage(locale.linkToCookiePolicy)}><span>{intl.formatMessage(locale.cookiePolicy)}</span></a>
            <span>© Universe {new Date().getFullYear()}</span>
          </div>
          <div className={style.socialMedia}>
            <a href="https://twitter.com/uniiverse" aria-label={intl.formatMessage(locale.linkToTwitter)}><TwitterIcon /></a>
            <a href="https://instagram.com/universe" aria-label={intl.formatMessage(locale.linkToInstagram)}><InstagramIcon /></a>
            <a href="https://facebook.com/universe" aria-label={intl.formatMessage(locale.linkToFacebook)}><FacebookIcon /></a>
          </div>
        </div>
      </div>
    </footer>
  )
}

export const Footer = injectIntl(FooterComponent)
